import React, { Component } from 'react';
import axios from 'axios';

class AdministratorPerson extends Component {
   constructor(props) {
      super(props);

      this.state = {
         loading: false,
         error: null,
         person: null,
         showDeleteModal: false,
         deleteDaysLeft: 0,
         filesStats: null,
      };

      this.handleModeChange = this.handleModeChange.bind(this);
      this.handleDelete = this.handleDelete.bind(this);
      this.openDeleteModal = this.openDeleteModal.bind(this);
      this.closeDeleteModal = this.closeDeleteModal.bind(this);
      this.handleDeleteDaysLeftChange = this.handleDeleteDaysLeftChange.bind(this);
      this.handleRestore = this.handleRestore.bind(this);
      this.handleDaysLeftChange = this.handleDaysLeftChange.bind(this);
      this.handleDaysLeftBlur = this.handleDaysLeftBlur.bind(this);
   }

   componentDidMount() {
      const pathParts = window.location.pathname.split('/').filter(Boolean);
      const personId = pathParts[pathParts.length - 1];

      if (!personId) {
         this.setState({ error: 'ID de persona no válido.' });
         return;
      }

      this.fetchPerson(personId);
   }

   fetchPerson(id) {
      this.setState({ loading: true, error: null });

      axios
         .get(`/api/administrator/people/${id}`)
         .then((response) => {
            this.setState({
               person: response.data,
               loading: false,
               deleteDaysLeft: response.data.days_left || 0,
            });

            // Cargar estadísticas de archivos
            this.fetchFilesStats(id);
         })
         .catch(() => {
            this.setState({
               loading: false,
               error: 'Ocurrió un error al cargar la información de la persona.',
            });
         });
   }

   fetchFilesStats(id) {
      axios
         .get(`/api/administrator/people/${id}/files-stats`)
         .then((response) => {
            this.setState({ filesStats: response.data });
         })
         .catch(() => {
            // No romper la vista si falla; opcionalmente podrías setear un error específico
         });
   }

   handleDaysLeftChange(event) {
      const value = event.target.value;

      // Solo permitir números vacíos o enteros positivos
      if (value === '' || /^\d+$/.test(value)) {
         this.setState((prevState) => ({
            person: {
               ...prevState.person,
               days_left: value === '' ? '' : Number(value),
            },
         }));
      }
   }

   handleDaysLeftBlur() {
      const { person } = this.state;

      if (!person) {
         return;
      }

      this.setState({ loading: true, error: null });

      axios
         .put(`/api/administrator/people/${person.id}/days-left`, {
            days_left:
               person.days_left === '' || person.days_left === null || person.days_left === undefined
                  ? null
                  : Number(person.days_left),
         })
         .then((response) => {
            this.setState({
               person: response.data,
               loading: false,
            });
         })
         .catch(() => {
            this.setState({
               loading: false,
               error: 'No se pudo actualizar days_left.',
            });
         });
   }

   handleRestore() {
      const { person } = this.state;

      if (!person) {
         return;
      }

      this.setState({ loading: true, error: null });

      axios
         .post(`/api/administrator/people/${person.id}/restore`)
         .then((response) => {
            this.setState({
               person: response.data,
               loading: false,
               showDeleteModal: false,
            });
         })
         .catch(() => {
            this.setState({
               loading: false,
               error: 'No se pudo restaurar la empresa.',
            });
         });
   }

   openDeleteModal() {
      const { person } = this.state;
      if (!person) {
         return;
      }

      this.setState({
         showDeleteModal: true,
         deleteDaysLeft: person.days_left || 0,
      });
   }

   closeDeleteModal() {
      this.setState({ showDeleteModal: false });
   }

   handleDeleteDaysLeftChange(event) {
      const value = event.target.value;
      this.setState({ deleteDaysLeft: value });
   }

   handleDelete() {
      const { person, deleteDaysLeft } = this.state;

      if (!person) {
         return;
      }

      this.setState({ loading: true, error: null });

      axios
         .delete(`/api/administrator/people/${person.id}`, {
            data: {
               days_left: deleteDaysLeft !== '' ? Number(deleteDaysLeft) : null,
            },
         })
         .then(() => {
            window.location.href = '/administrator';
         })
         .catch(() => {
            this.setState({
               loading: false,
               showDeleteModal: false,
               error: 'No se pudo eliminar la empresa.',
            });
         });
   }

   handleModeChange(event) {
      const newMode = event.target.value;
      const { person } = this.state;

      if (!person) {
         return;
      }

      const previousPerson = { ...person };

      // Actualización optimista
      this.setState({ person: { ...person, mode: newMode } });

      axios
         .put(`/api/administrator/people/${person.id}/mode`, { mode: newMode })
         .then((response) => {
            this.setState({ person: response.data });
         })
         .catch(() => {
            this.setState({
               person: previousPerson,
               error: 'No se pudo actualizar el modo del cliente.',
            });
         });
   }

   render() {
      const { loading, error, person, showDeleteModal, deleteDaysLeft, filesStats } = this.state;

      return (
         <div className="container mt-4">
            <h3>Detalle de Persona</h3>

            {loading && <div>Cargando...</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            {!loading && !error && person && (
               <div className="card mt-3">
                  <div className="card-body">
                     <div className="mb-2"><strong>ID:</strong> {person.id}</div>
                     <div className="mb-2"><strong>RFC:</strong> {person.rfc}</div>
                     <div className="mb-2"><strong>Razón social:</strong> {person.fiscal_name}</div>
                     <div className="mb-2"><strong>Nombre:</strong> {person.name}</div>
                     <div className="mb-2"><strong>Dirección:</strong> {person.address1}</div>
                     <div className="mb-2"><strong>Código Postal:</strong> {person.zipcode}</div>
                     {filesStats && (
                        <>
                           <div className="mb-2">
                              <strong>Total de archivos:</strong> {filesStats.files_count}
                           </div>
                           <div className="mb-2">
                              <strong>Espacio total ocupado:</strong> {filesStats.total_size_mb} MB
                           </div>
                        </>
                     )}
                     <div className="mb-2">
                        <strong>Días restantes  para eliminar archivos:</strong>
                        <input
                           type="number"
                           min="0"
                           className="form-control form-control-sm d-inline-block ml-2"
                           style={{ width: '120px' }}
                           value={person.days_left ?? ''}
                           onChange={this.handleDaysLeftChange}
                           onBlur={this.handleDaysLeftBlur}
                        />
                     </div>
                     <div className="mb-2">
                        <strong>Modo:</strong>
                        <select
                           className="form-control form-control-sm d-inline-block ml-2"
                           style={{ width: 'auto' }}
                           value={person.mode || 'completador'}
                           onChange={this.handleModeChange}
                        >
                           <option value="completador">completador</option>
                           <option value="cliente">cliente</option>
                        </select>
                     </div>

                     {person.deleted_at ? (
                        <button
                           type="button"
                           className="btn btn-success mt-3"
                           onClick={this.handleRestore}
                        >
                           Restaurar empresa
                        </button>
                     ) : (
                        <button
                           type="button"
                           className="btn btn-danger mt-3"
                           onClick={this.openDeleteModal}
                        >
                           Eliminar empresa
                        </button>
                     )}
                  </div>
               </div>
            )}

            {showDeleteModal && (
               <div className="modal fade show" style={{ display: 'block' }}>
                  <div className="modal-dialog" role="document">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h5 className="modal-title">Eliminar empresa</h5>
                           <button type="button" className="close" onClick={this.closeDeleteModal}>
                              <span>&times;</span>
                           </button>
                        </div>
                        <div className="modal-body">
                           <p>¿Estás seguro de que deseas eliminar esta empresa?</p>
                           <div className="form-group">
                              <label>Días restantes para eliminar archivos</label>
                              <input
                                 type="number"
                                 className="form-control"
                                 value={deleteDaysLeft}
                                 min="0"
                                 onChange={this.handleDeleteDaysLeftChange}
                              />
                           </div>
                        </div>
                        <div className="modal-footer">
                           <button type="button" className="btn btn-secondary" onClick={this.closeDeleteModal}>
                              Cancelar
                           </button>
                           <button
                              type="button"
                              className="btn btn-danger"
                              onClick={this.handleDelete}
                           >
                              Eliminar
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            )}
         </div>
      );
   }
}

export default AdministratorPerson;
